import React, { useRef, useState } from 'react';
import { Datagrid, TextField, useRefresh } from 'react-admin';

import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import { DialogoConfirmacao } from '../../Components';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import ListPageTabbed from '../../Components/ReactAdmin/List/ListPageTabbed';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import { PRIMARY_COLOR } from '../../utils';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils/constants';
import { PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR } from '../../utils/dadosTelas';
import DialogoCreateEdit from './DialogoCreateEdit';
import Filter from './Filter';

const useStyles = makeStyles(() => ({
  dataHeader: {
    flex: 1,
    backgroundColor: PRIMARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const tabs = [
  { id: 'ativos', name: 'Ativos', filter: { status: STATUS_ATIVO } },
  { id: 'inativos', name: 'Inativos', filter: { status: STATUS_INATIVO } },
];

const List = (props) => {
  const refDialogoConfirmacao = useRef(null);
  const refresh = useRefresh();
  const classes = useStyles();
  const [dialogo, setDialogo] = useState({
    open: false,
    id: null,
  });

  function handleCriar() {
    setDialogo({ open: true, id: null });
  }

  function handleEdit({ id }) {
    setDialogo({ open: true, id });
  }

  const handleClose = () => {
    refresh();
  };

  async function ativar(id) {
    await api.put(`/categorias_cliente/status/ativar/${id}`);
    handleClose();
  }

  async function desativar(id) {
    await api.put(`/categorias_cliente/status/inativar/${id}`);
    handleClose();
  }

  async function deletar(id) {
    await api.put(`/categorias_cliente/status/deletar/${id}`);
    handleClose();
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        return ativar(id);
      case 2:
        return desativar(id);
      case 3:
        return deletar(id);
      default:
    }
  }

  function handleAtivar(id) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'REATIVAR CATEGORIA DE CLIENTE',
        'Tem certeza que deseja reativar?',
        { id, codigo: 1 },
      );
    }
  }

  function handleInativar(id) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'INATIVAR CATEGORIA DE CLIENTE',
        'Tem certeza que deseja inativar?',
        { id, codigo: 2 },
      );
    }
  }

  function handleDeletar(id) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'DELETAR CATEGORIA DE CLIENTE',
        'Tem certeza que deseja deletar?',
        { id, codigo: 3 },
      );
    }
  }

  const toolbarActions = <ActionsList handleCriar={handleCriar} {...props} />;

  const renderGrid = () => (
    <Datagrid {...props}>
      <TextField
        source="nome"
        label="Descrição"
        headerClassName={classes.dataHeader}
        cellClassName={classes.dataCell}
        sortable={false}
      />
      <ActionsField
        textAlign="right"
        label="Ações"
        sortable={false}
        headerClassName={classes.dataHeader}
        cellClassName={classes.dataCell}
        actions={[
          {
            title: 'Editar',
            icon: <EditOutlinedIcon />,
            show: () => true,
            onClick: (r) => handleEdit(r),
          },
          {
            title: 'Ativar',
            icon: <CheckCircleOutlineIcon />,
            show: (r) => r.status === STATUS_INATIVO,
            onClick: (r) => handleAtivar(r.id),
          },
          {
            title: 'Desativar',
            icon: <ClearIcon />,
            show: (r) => r.status === STATUS_ATIVO,
            onClick: (r) => handleInativar(r.id),
          },
          {
            title: 'Excluir',
            icon: <DeleteOutlineIcon />,
            show: (r) => r.status === STATUS_INATIVO,
            onClick: (r) => handleDeletar(r.id),
          },
        ]}
      />
    </Datagrid>
  );

  return (
    <ProtegerPagina permissao={PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR}>
      <>
        <ListPageTabbed
          title="Categorias de Clientes"
          filters={<Filter />}
          toolbarActions={toolbarActions}
          renderGrid={renderGrid}
          perPage={50}
          tabs={tabs}
          filterDefaultValues={{ status: STATUS_ATIVO }}
          listProps={{ sort: { field: 'nome', order: 'asc' }, ...props }}
        />

        <DialogoConfirmacao
          ref={refDialogoConfirmacao}
          handleConfirma={handleConfirma}
        />
        <DialogoCreateEdit
          open={dialogo.open}
          id={dialogo.id}
          onClose={() => {
            setDialogo({ open: false, id: null });
            handleClose();
          }}
          isDialogoConfirmacaoActions
        />
      </>
    </ProtegerPagina>
  );
};

export default List;
